/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMapTransform } from '../../factoriesAny.js';
export var mapTransformDependencies = {
  typedDependencies,
  createMapTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMapTransform.generated.js
// module id = 1407
// module chunks = 2